// extracted by mini-css-extract-plugin
export default {"titleModal":"ModalComponent_titleModal__BuyZu","flexCenter":"ModalComponent_flexCenter__YCbNv","containerButton":"ModalComponent_containerButton__196f7"};